import {
  Flex,
  IconButton,
  IconTrashLine,
  List,
  Pill,
  Text,
  ToggleDetails,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { Card } from "../Card";

const Cycle = ({ cycle, setOpenDialog, setDeleteData, pathname }) => {
  const { t } = useTranslation();
  const handleDeleteCycle = (cycle) => {
    setDeleteData(cycle);
    setOpenDialog(true);
  };

  return (
    <Card style={{ backgroundColor: "#F2F8FA", height: "auto" }}>
      <ToggleDetails
        themeOverride={{ mediumIconSize: "1rem" }}
        defaultExpanded
        fluidWidth
        iconPosition="start"
        size="medium"
        summary={
          <Text margin="0 0 small 0">
            <Text weight="bold">{t("cyclesAndGoals.name")}: </Text>
            {cycle.name}
          </Text>
        }
      >
        <Flex
          justifyItems="space-between"
          alignItems="start"
          wrap="wrap"
          padding="small"
        >
          <Flex.Item size="100%" margin="0 0 small 0">
            <Text weight="bold">{t("cyclesAndGoals.cycleType.duration")} </Text>
            <Pill>{`${new Date(cycle.start_date).toLocaleDateString()} -
          ${new Date(cycle.end_date).toLocaleDateString()}`}</Pill>
          </Flex.Item>

          {!pathname && (
            <Flex.Item margin="0 0 0 small">
              <IconButton
                shape="rectangle"
                margin="none small none none"
                screenReaderLabel={t("cyclesAndGoals.deleteCycleButton")}
                onClick={() => handleDeleteCycle(cycle)}
                renderIcon={IconTrashLine}
              />
            </Flex.Item>
          )}
          {cycle.type && (
            <Flex.Item size="100%">
              <Text weight="bold">{t("cyclesAndGoals.typeIs")} </Text>
              {cycle.type.name}, {t("cyclesAndGoals.cycleType.durationEvery")}{" "}
              {cycle.type.duration}
            </Flex.Item>
          )}
          <Flex.Item size="100%" margin="small 0 0 0">
            <Text weight="bold">
              {t("cyclesAndGoals.cycleGoal.goalsAndObjectives")}
            </Text>
            {cycle.goals.map((goal, idx) => (
              <ToggleDetails
                key={idx}
                size="small"
                summary={
                  <Text as="div" size="small" weight="bold">
                    {t("cyclesAndGoals.goal")}:{" "}
                    <Text as="span" weight="normal" size="small">
                      {goal.description}
                    </Text>
                  </Text>
                }
              >
                <Text as="div" size="small" weight="bold">
                  {t("cyclesAndGoals.objective")}:
                </Text>
                <List size="small">
                  {goal.objectives.map((obj, key) => (
                    <List.Item key={key}>{obj.description}</List.Item>
                  ))}
                </List>
              </ToggleDetails>
            ))}
          </Flex.Item>

          {(cycle.parent_cycle || cycle.child_cycles.length > 0) && (
            <Flex.Item size="100%" margin="small 0 0 0">
              <Flex gap="small" alignItems="start" wrap="wrap">
                {cycle.parent_cycle &&
                  Object.hasOwn(cycle.parent_cycle, "name") && (
                    <Flex.Item
                      size={cycle.child_cycles.length > 0 ? "50%" : "100%"}
                    >
                      <span
                        style={{
                          fontSize: "0.9em",
                          color: "#156380",
                          fontWeight: "bold",
                        }}
                      >
                        {t("cyclesAndGoals.childOf")}
                      </span>
                      <span
                        style={{
                          display: "block",
                          paddingTop: "2px",
                          fontSize: "0.9em",
                          color: "#156380",
                        }}
                      >
                        {cycle.parent_cycle.name}
                      </span>
                    </Flex.Item>
                  )}

                {cycle.child_cycles.length > 0 && (
                  <Flex.Item>
                    <span
                      style={{
                        fontSize: "0.9em",
                        color: "#156380",
                        fontWeight: "bold",
                      }}
                    >
                      {t("cyclesAndGoals.parentOf")}
                    </span>
                    <List isUnstyled>
                      {cycle.child_cycles.map((child, idx) => (
                        <List.Item key={idx + 1}>
                          <span style={{ fontSize: "0.9em", color: "#156380" }}>
                            {child.name}
                          </span>
                        </List.Item>
                      ))}
                    </List>
                  </Flex.Item>
                )}
              </Flex>
            </Flex.Item>
          )}
        </Flex>
      </ToggleDetails>
    </Card>
  );
};

export default Cycle;
